import { DateTime } from "luxon";
import Select from "react-select";

import { CaseReportSignature, User, LocationCode } from "pwapi";

import "./SignatureField.css";

import CustomInput from "components/customInputs/CustomInput";

import { getLocationStringForSignature, PW_DATETIME_WITH_ZONE } from "./utils";

type SignatureFieldProps = {
  signatures: CaseReportSignature[];
  user?: User;
  value?: CaseReportSignature;
  onSelect: Function;
  locationCode?: LocationCode;
};

const formatSignatureOption = ({
  label,
  user,
  locationCode,
}: {
  label: CaseReportSignature;
  user?: User;
  locationCode?: LocationCode;
}) => {
  return (
    <div className="SignatureField SignatureField--vertical">
      <span>
        {user?.first_name} {user?.last_name}
        {user?.userprofile?.credentials
          ? `, ${user.userprofile?.credentials}`
          : ""}
      </span>
      {user?.userprofile.title && <span>{user?.userprofile.title}</span>}
      {label.clia_certificate?.location?.timezone && (
        <span>
          Final report electronically signed on{" "}
          {DateTime.local({
            zone: label.clia_certificate.location.timezone,
          }).toLocaleString({
            ...PW_DATETIME_WITH_ZONE,
            timeZoneName: "long",
          })}
        </span>
      )}
      <span>
        The professional component was performed at:{" "}
        {label.clia_certificate.name}, {getLocationStringForSignature(label)}
      </span>
      <span>
        CLIA #: {label.clia_certificate?.number}
        {locationCode && <> ; {locationCode.code}</>}
      </span>
    </div>
  );
};

const SignatureField = ({
  signatures,
  onSelect,
  user,
  value,
  locationCode,
}: SignatureFieldProps) => {
  return (
    <CustomInput label="Signature">
      <Select
        value={
          value
            ? { value: value.id, label: value, user, locationCode }
            : undefined
        }
        formatOptionLabel={formatSignatureOption}
        options={signatures?.map((sig) => ({
          value: sig.id,
          label: sig,
          locationCode,
          user,
        }))}
        onChange={(newValue) => {
          onSelect(newValue);
        }}
        className="SignatureField__select"
        placeholder="Select a signature"
      />
    </CustomInput>
  );
};

export default SignatureField;
